module.exports = __webpack_public_path__ + "img/memberLevelVP.04eb6ca7.png";